const _ = require('./underscore-mixins');
//const $ = require('jquery'); // use global jquery already included
const bootstrap = require('bootstrap');
require('./maps');
window._ = _;
window.bootstrap = bootstrap;